module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("asSmq"))).then(() => parcelRequire('hEqeo'));